<template>
  <div id="App">
     <div class="clear"></div>
<!--     <div class="public-foot">
        <div id="w-center" class="public-foot-center">
          <div class="public-foot-center-lfet">
              <ul class="public-foot-center-lfet-nav">
                <li><router-link :to="`/`">首页</router-link></li>
                <li><router-link :to="{path:'/Products',query: {index: 2}}">产品库</router-link></li>
                <li><router-link :to="{path:'/Qiyelist',query: {index: 8}}">企业库</router-link></li>
                <li><router-link :to="{path:'/Expert',query: {index: 3}}">专家服务</router-link></li>
                <li><router-link :to="{path:'/News',query: {index: 4}}">新闻资讯</router-link></li>
                <li><router-link :to="{path:'/Jobs',query: {index: 5}}">论坛交流</router-link></li>
                <li><router-link :to="{path:'/About',query: {index: 6}}">平台介绍</router-link></li>
                <li><router-link :to="{path:'/Aboutlx',query: {index: 7}}">联系平台</router-link></li>
              </ul>




              <div class="public-foot-center-lfet-di">
                <div class="public-foot-center-lfet-dizhi">
                  <div v-html="info.content"></div>
                </div>
                <div class="public-foot-center-lfet-ewm">
                  <img :src="info.picurl" alt=""><span>智医交流服务平台</span>
                </div>
              </div>
          </div>
          <div class="public-foot-center-right">
            <p class="public-foot-right-title"><span>Contact us</span><span>联系我们</span></p>
            <p class="public-foot-right-text">若您有合作意向，请您使用以下方式联系我们，您给我们多大信任我们给您多大惊喜！</p>
            <div class="foot-tel">
              <img src="../../../static/img/foottel.png" alt=""><span>{{info.tel}}</span>
            </div>
            <el-button  class="foot-zxtel"  icon="el-icon-chat-line-round" plain @click="$router.push('/Aboutlx?index=7&id=19')">在线咨询</el-button>
          </div>
          <div class="clear"></div>
        </div>
      </div> -->
      <!-- <div class="foot">
        <div id="w-center" class='foot_d'>
            <div class="w_foot_div"><img :src="info.logo" alt="" class="logo_imng logo_foot_imng"></div>
            <div class="w_foot_div">
              <p class="w_foot_p1">{{info.tel}}</p>
              <p class="w_foot_p2">{{info.address}}</p>
              <p class="w_foot_p3">{{info.yx}}</p>
            </div>
            <div class="w_foot_div">
              <ul class="w_foot_div_ul">
                <li><router-link :to="`/Index`" class="pub_duo">首页</router-link></li>
                <li><router-link :to="`/Goodscart`" class="pub_duo">购物车</router-link></li>
                <li><router-link :to="`/Orderlist`" class="pub_duo">我的订单</router-link></li>
                <li><router-link :to="`/Member`" class="pub_duo">会员中心</router-link></li>
              </ul>
            </div>
            <div class="xian1"></div>
            <div class="xian2"></div>
        </div>
        <div class="clear"></div>
      </div> -->
	  
	  
	  <div class="foot" style="background-color: #2f2f2f;">
	    <div id="w-center" class='foot_d' style="border-bottom: 1px solid #4e4d4e;padding-bottom: 20px;">
	        <div class="w_foot_div">
				<p class="w_foot_tel" style="color: #444444;font-size:35px;font-style: italic;">Contact us <span style="color: #e0e0e0;font-size:16px;">联系我们</span></p>
				<!-- <p class="w_foot_p1">{{info.tel}}</p> -->
				<p class="w_foot_p2" style="margin-top: 20px;">邮箱：{{info.yx}}</p>
				<p class="w_foot_p2">电话：{{info.tel}}</p>
				<p class="w_foot_p2">传真：{{info.cz}}</p>
				<p class="w_foot_p2">地址：{{info.address}}</p>
	        </div>
			<div>
				<div style="color: #ffffff; display: flex;align-items: center;font-size: 22px;margin-top: 50px;">
					<img src="/static/img/tell.png" alt=""  style="margin-right: 4px;"/>全国统一免费咨询热线
				</div>
				<div style="color: #d2d9e0; display: flex;align-items: center;font-size: 22px;margin-top: 8px;">
					<img src="/static/img/telll.png" alt="" style="margin-right: 4px;" />{{info.zxrx}}
				</div>
			</div>
	        <div class="w_foot_div" >
				<div style="float: right;">
					<img :src="info.ewm" alt="" style="width: 100px;height: 100px;margin-top: 30px;" />
					<p style="color: #ffffff;text-align: center;width: 100px;margin-top: 10px;font-size: 15px;">二维码</p>
				</div>
				
	         <!-- <ul class="w_foot_div_ul">
	            <li><router-link :to="`/Index`" class="pub_duo">首页</router-link></li>
	            <li><router-link :to="`/Goodscart`" class="pub_duo">购物车</router-link></li>
	            <li><router-link :to="`/Orderlist`" class="pub_duo">我的订单</router-link></li>
	            <li><router-link :to="`/Member`" class="pub_duo">会员中心</router-link></li>
	          </ul> -->
	        </div>
	        <!-- <div class="xian1"></div> -->
	        <!-- <div class="xian2"></div> -->
	    </div>
	    <div class="clear"></div>
	  </div>
	  
	  
      <div class="bq_foot">{{info.dbbq}}</div>
  </div>
</template>
<script>
  export default{
    data(){
      return {
        info:[],

      }
    },
    components: {
    },
    mounted () {
      this.recordapi();
    },
    methods:{
      recordapi(){
          var that = this;

            that.$api.post("/Member/foot").then(res => {
              console.log(res);
              that.info= res.info;
            });
      },

    }

   }
</script>
<style>
	.w_foot_p2{color:#9f9f9f;font-size:15px}
</style>


// WEBPACK FOOTER //
// src/components/public/foot.vue